module.exports = __webpack_public_path__ + "img/ic_youtube.2d37e5ab.svg";